import React from 'react'
import { RouteObject } from 'react-router-dom'
import { AuthGuard } from '@components/guards/AuthGuard'
import { MK_BOOK_PATH } from '@constants'
import { lazyPage } from '../../utils/routeUtils'

/**
 * Booking Flow Architecture
 * ------------------------
 * The booking flow is structured as a multi-step process:
 *
 * 1. Search & Select - User selects dates, resort, room type
 * 2. Review & Customize - User reviews selection, adds extras
 * 3. Payment & Details - User enters payment information
 * 4. Confirmation - Booking confirmation details
 *
 * Each step is implemented as a separate route to enable:
 * - Direct linking to specific booking steps
 * - Better state management with URL parameters
 * - Improved analytics tracking
 */

/**
 * Booking related routes configuration
 * Handles all booking flow, reservation, and checkout related routes
 */
export const bookRoutes: RouteObject[] = [
  {
    path: MK_BOOK_PATH,
    element: <AuthGuard>{lazyPage('MkPageBook', 'book')}</AuthGuard>,
  },
]
